import classNames from 'classnames';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

// action creators
import { tooltipAdd, tooltipRemove } from '../../actions/tooltipActions';

// components
import { Panel, PanelBody, PanelHeader } from './_panel';

class Modal extends React.Component {
  static propTypes = {
    add:      PropTypes.func.isRequired,
    header:   PropTypes.string,
    id:       PropTypes.string.isRequired,
    remove:   PropTypes.func.isRequired,
    tooltip:  PropTypes.instanceOf(Immutable.Map)
  }

  componentWillMount() {
    const { id, add } = this.props;

    add(id);
  }

  componentWillUnmount() {
    const { id, remove } = this.props;

    remove(id);
  }

  render() {
    const { children, className, id, tooltip } = this.props;

    const active = ((tooltip.get('data') || Immutable.Map()).get(id) || Immutable.Map()).get('active');

    let element = null;

    if (active) {
      element = (
        <div className='modal-overlay'>
          <Panel className={ classNames('modal-panel', className) }>
            { this._renderHeader() }
            <PanelBody>
              { children }
            </PanelBody>
          </Panel>
        </div>
      );
    }

    return element;
  }

  // private

  _renderHeader() {
    const { header } = this.props;

    let element = null;

    if (header) {
      element = (
        <PanelHeader>
          <span className='panel__header__label'>{ header }</span>
        </PanelHeader>
      );
    }

    return element;
  }
}

const mapStateToProps = (state) => {
  return {
    tooltip: state.get('tooltip')
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    add: (id) => {
      dispatch(tooltipAdd(id));
    },

    remove: (id) => {
      dispatch(tooltipRemove(id));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Modal);



// WEBPACK FOOTER //
// ./app/components/shared/_Modal.jsx